<script>
import entry from '../../entry';
import _7 from './_7.vue';
import _6 from './_6.vue';
import _4 from './_4.vue';
import _2 from './_2.vue';
import _0 from './_0.vue';

export default entry({
  name: 'setting-shopinfo-entry',
  components: {
    _0,
    _2,
    _7,
    _6,
    _4
  },
  map: {
    0: '_0',
    2: '_2',
    7: '_7',
    6: '_6',
    4: '_4'
  }
});
</script>
